import { useParams, useNavigate } from 'react-router-dom';
import { Loader } from '../components/loader';
import { QuestionView } from '../components/question-view';
import { useQuestions, useSaveProgress } from '../hooks/use-course';
import { QuestionAttempt } from '../interfaces/course';
import { Sentry } from '../lib/sentry';

const QuestionsPage = () => {
  const navigate = useNavigate();
  const { courseId, levelId } = useParams();

  const { data, isLoading, error } = useQuestions(
    parseInt(courseId!, 10),
    parseInt(levelId!, 10),
  );

  const saveProgressMutation = useSaveProgress(
    parseInt(courseId!, 10),
    parseInt(levelId!, 10),
  );

  const handleComplete = async (attempts: QuestionAttempt[]) => {
    try {
      await saveProgressMutation.mutateAsync({ attempts });
      return true;
    } catch (err) {
      Sentry.captureException(err);
      return false;
    }
  };

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main p-6">
        <h1 className="text-xl font-bold text-incorrect mb-4">Error</h1>
        <p className="text-title mb-2">
          {error.message === 'You do not have access to this course'
            ? 'Access Denied'
            : 'Failed to load questions. Please try again.'}
        </p>
        <p className="text-sm text-subheading">{error.message}</p>
        <button
          onClick={() => navigate('/courses')}
          className="mt-4 bg-accent-purple text-white px-4 py-2 rounded-lg"
        >
          Back to My Courses
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main">
      <QuestionView
        questions={data?.questions || []}
        backUrl={`/courses/${courseId}?refresh=${Date.now()}`}
        onComplete={handleComplete}
      />
    </div>
  );
};

export default QuestionsPage;
